import $ from 'jquery'
import { Keyboard, MediaQuery } from './../../js/libraries/foundation'


const HOVER_DELAY = 250
const CLOSING_TIME = 100

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

function init() {
  const menu = document.querySelector('[data-menu]')

  if (!menu) return

  const isSmall = MediaQuery.upTo('large')
  const hasTouch = 'ontouchstart' in window
  const topItems = Array.from(menu.children)
  const items = Array.from(menu.querySelectorAll('[data-menu-item]'))
  const timers = new Map()
  let openItem = null

  // Arrow keys follow the menu orientation: horizontal on desktop, vertical in the mobile drawer
  const keys = isSmall
    ? { next: 'ArrowDown', prev: 'ArrowUp', open: 'ArrowRight', close: 'ArrowLeft' }
    : { next: 'ArrowRight', prev: 'ArrowLeft', open: 'ArrowDown', close: 'ArrowUp' }

  const getTrigger = item => item.querySelector('[data-menu-trigger]')
  const getSub = item => item.querySelector('[data-menu-sub]')
  const isPinned = item => item.dataset.isClick === 'true'

  function focusFirstIn(element) {
    const $focusable = Keyboard.findFocusable($(element))
    if ($focusable.length) {
      $focusable.eq(0).focus()
    }
  }

  function clearTimer(item) {
    clearTimeout(timers.get(item))
    timers.delete(item)
  }

  function open(item, { pinned = false, focus = false } = {}) {
    clearTimer(item)
    if (openItem && openItem !== item) {
      close(openItem)
    }

    item.classList.add('is-active')
    getSub(item).classList.add('js-dropdown-active')
    getTrigger(item).setAttribute('aria-expanded', 'true')
    if (pinned) {
      item.dataset.isClick = 'true'
    }
    openItem = item

    if (focus) {
      setTimeout(function () {
        focusFirstIn(getSub(item))
      }, 0)
    }
  }

  function close(item, { restoreFocus = false } = {}) {
    if (!item) return

    clearTimer(item)
    if (!item.classList.contains('is-active')) return

    const sub = getSub(item)
    // Never leave focus on an element that becomes hidden
    const focusInside = sub.contains(document.activeElement)

    item.classList.remove('is-active')
    sub.classList.remove('js-dropdown-active')
    getTrigger(item).setAttribute('aria-expanded', 'false')
    delete item.dataset.isClick
    if (openItem === item) {
      openItem = null
    }

    if (restoreFocus || focusInside) {
      getTrigger(item).focus()
    }
  }

  items.forEach(function (item) {
    const trigger = getTrigger(item)
    const parentLink = item.querySelector('a.Menu-link')

    trigger.addEventListener('click', function (e) {
      // detail === 0: activated with Enter / Space
      const isKeyboard = e.detail === 0

      if (item !== openItem) {
        open(item, { pinned: true, focus: true })
      } else if (isKeyboard) {
        close(item)
      } else if (!isPinned(item)) {
        // Opened by hover: a click keeps it open after the pointer leaves
        item.dataset.isClick = 'true'
      } else if (!hasTouch) {
        close(item)
      }
    })

    // Entry with both a link and a submenu: first tap opens the submenu, second one follows the link
    if (parentLink) {
      parentLink.addEventListener('click', function (e) {
        if ((isSmall || hasTouch) && e.detail !== 0 && !isPinned(item)) {
          e.preventDefault()
          open(item, { pinned: true, focus: true })
        }
      })
    }

    item.querySelectorAll('[data-menu-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        close(item, { restoreFocus: true })
      })
    })

    if (!isSmall) {
      item.addEventListener('mouseenter', function () {
        clearTimer(item)
        timers.set(item, setTimeout(function () {
          open(item)
        }, HOVER_DELAY))
      })

      item.addEventListener('mouseleave', function () {
        if (isPinned(item)) return
        clearTimer(item)
        timers.set(item, setTimeout(function () {
          close(item)
        }, CLOSING_TIME))
      })
    }
  })

  // Following any link of the menu closes the open submenu
  menu.addEventListener('click', function (e) {
    if (e.defaultPrevented || !e.target.closest('a')) return
    close(openItem)
  })

  document.addEventListener('click', function (e) {
    if (openItem && !menu.contains(e.target)) {
      close(openItem)
    }
  })

  // Escape must dismiss the submenu even when it was opened by hover and focus is elsewhere
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openItem) return
    close(openItem, { restoreFocus: openItem.contains(document.activeElement) })
  })

  menu.addEventListener('keydown', function (e) {
    const item = e.target.closest('.Menu-item')
    if (!item) return

    const sub = getSub(item)

    if (sub && sub.contains(e.target)) {
      const cards = Array.from(sub.querySelectorAll('.Menu-subItem > a'))
      const index = cards.indexOf(e.target)

      if (e.key === 'ArrowDown' && index > -1 && cards[index + 1]) {
        e.preventDefault()
        cards[index + 1].focus()
      } else if (e.key === 'ArrowUp' && index > 0) {
        e.preventDefault()
        cards[index - 1].focus()
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault()
        close(item, { restoreFocus: true })
      }
      return
    }

    const index = topItems.indexOf(item)

    if (e.key === keys.next || e.key === keys.prev) {
      const sibling = topItems[e.key === keys.next ? index + 1 : index - 1]
      if (sibling) {
        e.preventDefault()
        sibling.querySelector('.Menu-link').focus()
      }
    } else if (e.key === keys.open && sub) {
      e.preventDefault()
      open(item, { pinned: true, focus: true })
    } else if (e.key === keys.close && item === openItem) {
      e.preventDefault()
      close(item)
    }
  })
}
